export const mapContactsToForm = (notificationContacts) => {
    return notificationContacts.map(({ id, value, valueType, notifyOnActions }) => ({
        id,
        value,
        valueType,
        notifyOnActions
    }));
};
